import { CommonListData, RequestType, SORTING_ORDER } from 'common/constants/app.constant';
import { BHMetaModel, BaseDataModel, BaseMetaModel } from './base.model';

export type paginationType = 'load more' | 'change page';

export class ListModel<T> extends BaseDataModel {
    searchText: string = '';
    pages: number[];
    recordPerPage: number;
    selectedPage: number;
    totalRecords: number;
    listMaster: T[];
    list: T[];
    pageModel: T[];
    filterList: T[];
    extraPageData: any = {};
    errorModel: any = [];
    searchState: boolean = false;
}

export class ListParams {
    id: number | null = null;
}

export class QueryParams extends ListParams {
    apiParams: any = {};
    searchText: string = '';
    sortBy: HeadersList;
    orderBy: SORTING_ORDER;
    minMaxFilter: MinMaxFilter[] = [];
    typeFilter: typeFilter[] = [];
    recordPerPage: number = CommonListData.rowPerPage;
    sortingFeild: HeadersList;
    currentPage: number = 1;
    paginationType: paginationType = 'load more';
    filterFeilds: string[] = [];
    filterValue: string = '';
    customTypeFilter: string = '';
    search: string = '';
    searchState: boolean = false;
}

// export class GridParams extends QueryParam {
//     recordPerPage: number = CommonGridData.rowPerPage;
//     currentPage: number = 1;
//     sortingFeild: Headers;
//     sortingOrder: SORTING_ORDER;
//     filterFeilds: string[] = [];
// }
export class MinMax {
    min: any = null;
    max: any = null;
}

export class MinMaxFilter {
    rangeValue = new MinMax();
    fieldName: string;
}

export class typeFilter {
    feildName: string;
    value: string;
}

export class HeadersList {
    constructor(
        public readonly displayName: string,
        public readonly keyName: string,
        public readonly isSerchable: boolean,
        public readonly isSortable: boolean,
        public readonly feildType: string,
        public readonly isMinMaxSort: boolean = false,
        public readonly isFilterByValue: boolean = false,
        public sortingOrder: SORTING_ORDER = '0' // public colWidth: string = ''
    ) {}
}

export class ComponentData {
    operation: RequestType = RequestType.GET;
}
export class ListComponentData extends ComponentData {
    pageData: any = {};
    searchText: string = '';
    selectedPage: number;
    recordPerPage: number;
    sortingFeild: HeadersList;
    searchableFeilds: string[] = [];
    minMaxFilter: MinMaxFilter[] = [];
    curruntActiveList: string = '';
}

export abstract class ListMetaModel<T> extends BHMetaModel {
    constructor(name: string, redirectPath: string, protected isEditable: boolean, protected recordPerPage: number, protected redirectBackPath: string) {
        super(name, redirectPath, false, redirectBackPath);
    }

    abstract prepareHeaderList(): T[];

    getMetaModel(): BaseMetaModel {
        const pageData = new BaseMetaModel();
        pageData.pageTitle = this.pageTitle;
        pageData.properties = this.initProperties();
        pageData.redirectPath = this.redirectPath;
        pageData.headerButtonPath = this.redirectBackPath;
        return pageData;
    }

    initProperties(): any {
        const dataInfo = {
            isEditable: this.isEditable,
            recordPerPage: this.recordPerPage,
            listInfo: this.prepareHeaderList(),
            pointer: undefined,
            isSortOpen: false,
            isFilterOpen: false,
        };
        return dataInfo;
    }
}
